<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="标题" prop="title" >
        <a-input v-model="form.title" placeholder="请输入标题" />
      </a-form-model-item>
      <a-form-model-item label="副标题" prop="subTitle" >
        <a-input v-model="form.subTitle" placeholder="请输入副标题" />
      </a-form-model-item>
      <a-form-model-item label="修图师头像" prop="avatar" >
        <a-input v-model="form.avatar" placeholder="请输入修图师头像" />
      </a-form-model-item>
      <a-form-model-item label="修图师昵称" prop="nickname" >
        <a-input v-model="form.nickname" placeholder="请输入修图师昵称" />
      </a-form-model-item>
      <a-form-model-item label="修图订单id,外键{zb_order_refinement.id}" prop="orderId" >
        <a-input v-model="form.orderId" placeholder="请输入修图订单id,外键{zb_order_refinement.id}" />
      </a-form-model-item>
      <a-form-model-item label="用户id，外键{zb_user.id}" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户id，外键{zb_user.id}" />
      </a-form-model-item>
      <a-form-model-item label="是否已读,0-未读,1-已读" prop="read" >
        <a-input v-model="form.read" placeholder="请输入是否已读,0-未读,1-已读" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAssistant, addAssistant, updateAssistant } from '@/api/message/assistant'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        title: null,

        subTitle: null,

        avatar: null,

        nickname: null,

        orderId: null,

        userId: null,

        read: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        subTitle: [
          { required: true, message: '副标题不能为空', trigger: 'blur' }
        ],
        avatar: [
          { required: true, message: '修图师头像不能为空', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: '修图师昵称不能为空', trigger: 'blur' }
        ],
        orderId: [
          { required: true, message: '修图订单id,外键{zb_order_refinement.id}不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户id，外键{zb_user.id}不能为空', trigger: 'blur' }
        ],
        read: [
          { required: true, message: '是否已读,0-未读,1-已读不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        subTitle: null,
        avatar: null,
        nickname: null,
        orderId: null,
        userId: null,
        read: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAssistant({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateAssistant(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAssistant(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
